// Import all supplier packages
import { frogfootPackages } from './frogfoot';
import { openservePackages } from './openserve';
import { octotelPackages } from './octotel';
import { vumatelPackages } from './vumatel';
import { metrofibrePackages } from './metrofibre';
import { seacomPackages } from './seacom';
import { centuryCityPackages } from './centurycity';
import { lightwirePackages } from './lightwire';
import { ttConnectPackages } from './ttconnect';
import { openFibrePackages } from './openfibre';
import { fttbPackageIds } from './fttbPackages';

// Export all packages
export {
  frogfootPackages,
  openservePackages,
  octotelPackages,
  vumatelPackages,
  metrofibrePackages,
  seacomPackages,
  centuryCityPackages,
  lightwirePackages,
  ttConnectPackages,
  openFibrePackages,
  fttbPackageIds
};

// Combine all packages into a single array
export const allPackages = [
  ...frogfootPackages,
  ...openservePackages,
  ...octotelPackages,
  ...vumatelPackages,
  ...metrofibrePackages,
  ...seacomPackages,
  ...centuryCityPackages,
  ...lightwirePackages,
  ...ttConnectPackages,
  ...openFibrePackages
];